import React from 'react';
import PaddleCheckout from '../components/PaddleCheckout/PaddleCheckout';
import { useNavigate } from 'react-router-dom';

const PaddleTest = () => {
  const navigate = useNavigate();

  return (
    <div style={{ 
      padding: '20px', 
      maxWidth: '800px', 
      margin: '0 auto',
      fontFamily: 'Arial, sans-serif'
    }}>
      <h1>Paddle Checkout Test</h1>
      <p>This page tests the Paddle.js inline checkout integration.</p>
      
      <div style={{ marginBottom: '20px' }}>
        <button 
          onClick={() => navigate('/')}
          style={{
            padding: '10px 20px',
            background: '#667eea',
            color: 'white',
            border: 'none',
            borderRadius: '5px',
            cursor: 'pointer'
          }}
        >
          Back to Home
        </button>
      </div>

      <div style={{ 
        background: '#f5f5f5', 
        padding: '20px', 
        borderRadius: '8px',
        marginBottom: '20px'
      }}>
        <h3>Test Order Information:</h3>
        <ul>
          <li>Order ID: test_order_123</li>
          <li>Product: Test Product</li>
          <li>Price: $9.99</li>
        </ul>
      </div>

      <PaddleCheckout 
        orderId="test_order_123"
        orderData={{
          address: {
            description: "Test Address",
            first_line: "123 Test St",
            city: "Test City",
            postal_code: "12345",
            region: "Test Region",
            country_code: "US"
          }
        }}
      />
    </div>
  );
};

export default PaddleTest; 